export * from './user-settings.component';



// WEBPACK FOOTER //
// ./src/app/components/user-settings/index.ts